import { render } from "./HistorySearch.vue?vue&type=template&id=cbaba710"
import script from "./HistorySearch.vue?vue&type=script&lang=js"
export * from "./HistorySearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__